import React, { useState } from "react";
import { CommonModal, CommonButton } from "../../Input";
import AmountStep from "./modals/AmountStep";
import QRStep from "./modals/QRStep";
import UENStep from "./modals/UENStep";
import BankTransferStep from "./modals/BankTransferStep";
import ATMStep from "./modals/ATMStep";
import SuccessStep from "./modals/SuccessStep";

const TopupModal = ({
  show,
  onHide,
  selectedMethod,
  amount,
  setAmount,
  selectedCurrency,
  setSelectedCurrency,
  currencies,
  handleConfirm,
}) => {
  const [step, setStep] = useState(1);
  const [receiptFiles, setReceiptFiles] = useState([]);
  const verificationCode = "6QL9S4";

  const resetAndHide = () => {
    setStep(1);
    setReceiptFiles([]);
    onHide();
  };

  const nextStep = () => {
    if (step === 1) {
      setStep(2);
    } else if (step === 2) {
      handleConfirm();
      setStep(3);
    } else {
      resetAndHide();
    }
  };

  const isConfirmDisabled =
    step === 2 && selectedMethod?.id === "atm" && receiptFiles.length === 0;

  const renderStepContent = () => {
    if (step === 3) {
      return <SuccessStep />;
    }

    if (step === 1) {
      return (
        <AmountStep
          amount={amount}
          setAmount={setAmount}
          selectedCurrency={selectedCurrency}
          setSelectedCurrency={setSelectedCurrency}
          currencies={currencies}
        />
      );
    }

    // Step 2 content based on method
    const step2Props = {
      amount,
      currencyCode: selectedCurrency.code,
      verificationCode,
      receiptFiles,
      setReceiptFiles,
    };

    switch (selectedMethod?.id) {
      case "qr":
        return <QRStep {...step2Props} />;
      case "uen":
        return <UENStep {...step2Props} />;
      case "bank":
        return <BankTransferStep {...step2Props} />;
      case "atm":
        return <ATMStep {...step2Props} />;
      default:
        return null;
    }
  };

  return (
    <>
      <CommonModal
        show={show}
        onHide={resetAndHide}
        title={selectedMethod?.subTitle || "Topup"}
        size="md"
        scrollable={step === 2}
        modalProps={{
          centered: true,
        }}
        footer={
          <div className="d-flex gap-3 w-100 mt-0">
            {step !== 3 && (
              <CommonButton
                variant="light"
                className="flex-fill border py-2 fs-15 fw-bold"
                onClick={step === 2 ? () => setStep(1) : resetAndHide}
              >
                {step === 2 ? "Back" : "Cancel"}
              </CommonButton>
            )}
            <CommonButton
              variant="primary"
              className="flex-fill py-2 fs-15 fw-bold"
              onClick={nextStep}
              disabled={isConfirmDisabled}
            >
              {step === 3
                ? "Done"
                : step === 2
                  ? "I have transferred the funds"
                  : "Confirm"}
            </CommonButton>
          </div>
        }
      >
        {renderStepContent()}
      </CommonModal>

      <style>{`
        .currency-dropdown-group .btn-light:hover,
        .currency-dropdown-group .btn-light:focus,
        .currency-dropdown-group .btn-light:active,
        .currency-dropdown-group .show > .btn-light.dropdown-toggle {
          border-color: #d5dfe7 !important;
          background-color: #fff !important;
          box-shadow: none !important;
          outline: none !important;
        }

        /* Remove arrows from number input */
        .amount-field-premium::-webkit-outer-spin-button,
        .amount-field-premium::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        .amount-field-premium[type=number] {
          -moz-appearance: textfield;
        }
        .amount-field-premium:focus {
          border-color: #d5dfe7 !important;
          box-shadow: none !important;
          outline: none !important;
        }

        .dropdown-currency-menu .dropdown-item:hover {
          background-color: #f8faff;
        }
        .dropdown-currency-menu .dropdown-item:active {
          background-color: #eef2ff;
        }
        .text-orange { color: #F97316; }
      `}</style>
    </>
  );
};

export default TopupModal;
